Spruce.store('toggles', {
  showMenu: false,
  showOverlay: false,
  showShippingInfo: false,
  showSizeChart: false,

  resetAll() {
    this.showMenu = false;
    this.showOverlay = false;
    this.showShippingInfo = false;
    this.showSizeChart = false;
  }
});

function isBlank(value) {
  return value == null || value == undefined || value == '';
}

function money(value) {
  let formatter =  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  return formatter.format(value / 100.0);
}

function lineItem(item) {
  return {
    ...item,
    quantityChange: 0,

    isMinimumQuantity() { return this.quantity <= 1; },
    isMaximumQuantity() { return this.quantity >= this.max; },

    decrement() {
      this.quantity -= 1;
      this.quantityChange -= 1;
    },

    increment() {
      this.quantity += 1;
      this.quantityChange += 1;
    },

    async remove() {
      updateCart({ id: this.key, quantity: 0 });
      document.getElementById(`item-${this.key}`).remove();
    },

    update() {
      this.$store.cart.count += this.quantityChange;
      this.quantityChange = 0;
      updateCart({ id: this.key, quantity: this.quantity });
    },

    get finalLinePrice() {
      return money(this.price * this.quantity);
    }
  };
}

function productForm(variantId) {
  return {
    addedToCart: false,
    showError: false,

    async addToCart(e) {
      this.showError = false;

      let form = e.target;
      let data = Object.fromEntries(new FormData(form));

      let formData = { items: [data] };
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        this.addedToCart = true;
        this.$store.cart.count += 1;
      }
      else {
        let json = await response.json();
        console.error('Failed to add to trunk', json);
        this.showError = true;
      }
    }
  };
}

function setupCartStore(cartItems, total) {
  Spruce.store('cart', {
    count: cartItems,
    total: total,

    get isEmpty() { return this.count == 0; },
    get isFull() { return !this.isEmpty; },

    get formattedTotal() {
      return money(this.total);
    }
  });
}

function contactForm() {
  return {
    name: null,
    email: null,
    phone: null,
    message: null,

    get submitDisabled() {
      return isBlank(this.name) ||
        isBlank(this.email) ||
        isBlank(this.phone) ||
        isBlank(this.message);
    }
  };
}

async function updateCart(data) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });

  let response = await fetch('/cart.js');
  let cart = await response.json();

  let cartStore = Spruce.store('cart');
  cartStore.count = cart.item_count;
  cartStore.total = cart.total_price;
}
